import { checkIfUserTypeIsAllowed } from '../utils/access-control'
import { TipoUsuario } from '@/core/enums/tipo-usuario'
import {
  Idioma,
  IdiomaInfo,
  useKeycloak
} from '@tecsinapse-org/portal-menu-kit'
import { useEffect } from 'react'
import { i18n } from '@/i18n'
import { useUsuarioLogado } from '@/core/hooks/use-usuario-logado'

export const useApp = () => {
  const { usuarioLogado: currentUser } = useUsuarioLogado()

  const { logout } = useKeycloak()

  useEffect(() => {
    if (!currentUser?.idioma?.id) return
    const idiomaAtual = Idioma[currentUser.idioma.id as keyof typeof Idioma]
    if (idiomaAtual && IdiomaInfo[idiomaAtual]) {
      i18n.activate(IdiomaInfo[idiomaAtual].language)
    }
  }, [currentUser])

  const showOptionSuperAdmin = checkIfUserTypeIsAllowed(currentUser?.tipo, [
    TipoUsuario.TECSINAPSE
  ])

  const customOptions = showOptionSuperAdmin
    ? [
        {
          label: 'SuperAdmin',
          path: '/superAdmin'
        }
      ]
    : undefined

  return {
    logout,
    customOptions,
    currentUser
  }
}
